import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import BloqueoElectrico from '../components/BloqueoElectrico';
import DescargoElectrico from '../components/DescargoElectrico';
import html2pdf from 'html2pdf.js';
import HptPdfTemplate from '../components/HptPdfTemplate';


const API_URL = process.env.REACT_APP_API_URL;

const PlanificadorScreen = () => {
    const navigate = useNavigate();

    // LÓGICA DE PERMISOS DE EDICIÓN BLOQUEOS: Extraemos el rol del token
    let userRol = '';
    const token = localStorage.getItem('userToken');
    if (token) {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            userRol = payload.rol || '';
        } catch(e) { console.error("Error leyendo token"); }
    }

    // Comprobamos si tiene permiso (Añadimos JEFE_TURNO y JEFE TURNO por si acaso)
    const puedeEditarDescargos = ['ADMINISTRADOR', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO'].includes(userRol.toUpperCase());

    // Permisos para cambiar estado
    const puedeCambiarEstado = ['ADMINISTRADOR', 'GESTOR', 'JEFE_TURNO', 'SUPERVISOR'].includes(userRol.toUpperCase());
    
    // --- ESTADOS ---
    const [hptsCompletas, setHptsCompletas] = useState([]); // Todas las HPTs finalizadas
    const [descargosGuardados, setDescargosGuardados] = useState({}); // Mapa de descargos por ID de HPT
    const [fechaActual, setFechaActual] = useState(new Date()); // Fecha del calendario (por defecto HOY)
    const [loading, setLoading] = useState(true);

    // Catálogos eléctricos para los buscadores predictivos del planificador
    const [electricosBloqueo, setElectricosBloqueo] = useState([]);
    const [electricosDescargo, setElectricosDescargo] = useState([]);

    // Estados de control para la ventana flotante LOTO
    const [bloqueosElectricos, setBloqueosElectricos] = useState([]);
    const [descargosElectricos, setDescargosElectricos] = useState([]);
    const [showLotoModal, setShowLotoModal] = useState(false);
    const [hptSeleccionada, setHptSeleccionada] = useState(null);
    const [tipoLoto, setTipoLoto] = useState(''); // 'descargo_electrico' o 'bloqueo_electrico'
    const [filasLotoTmp, setFilasLotoTmp] = useState([]); // Buffer de filas en edición
    const [numManualLoto, setNumManualLoto] = useState('');
    const [ptwVinculadoLoto, setPtwVinculadoLoto] = useState('');

    // --- ESTADOS PARA VER HOJAS DE BLOQUEO/DESCARGO ---
    const [showViewBloqueoModal, setShowViewBloqueoModal] = useState(false);
    const [viewBloqueoActivo, setViewBloqueoActivo] = useState(null);
    
    const [showViewDescargoModal, setShowViewDescargoModal] = useState(false);
    const [viewDescargoActivo, setViewDescargoActivo] = useState(null);
    
    const [hptLotoActiva, setHptLotoActiva] = useState(null);

    // --- CARGA DE PDF UNIFICADO ---
    // Referencia para la plantilla PDF
    const pdfRef = useRef();

    // Estado temporal para los datos del PDF en segundo plano
    const [datosPdf, setDatosPdf] = useState(null);
    const [opcionesPdf, setOpcionesPdf] = useState({
        base: true, trabajadores: true, escalera: true, plataforma: true,
        bloqueoA4: false, bloqueoA5: false, descargoA4: false, descargoA5: false
    });

    // ============================================================================
    // CARGA DE DATOS INICIAL
    // ============================================================================
    useEffect(() => {
        const fetchPlanificaciones = async () => {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            
            try {
            // Descargamos todo en paralelo para optimizar la velocidad
            const [resHpts, resBloq, resDesc] = await Promise.all([
                axios.get(`${API_URL}/api/hpt/planificador/completadas`, config),
                axios.get(`${API_URL}/api/catalogos/electricosBloqueo`, config),
                axios.get(`${API_URL}/api/catalogos/electricosDescargo`, config)
            ]);
            
            setHptsCompletas(resHpts.data);
            setElectricosBloqueo(resBloq.data.results || resBloq.data);
            setElectricosDescargo(resDesc.data.results || resDesc.data);

            
        } catch (error) {
            console.error("Error al cargar datos del planificador:", error);
            Swal.fire('Error', 'No se pudieron cargar las planificaciones o catálogos LOTO', 'error');
        } finally {
            setLoading(false);
        }
        };

        fetchPlanificaciones();
    }, []);

    // ============================================================================
    // LÓGICA DEL CALENDARIO Y FILTRADO
    // ============================================================================
    
    // Suma o resta días saltando fines de semana
    const cambiarDia = (dias) => {
        let nuevaFecha = new Date(fechaActual);
        
        do {
            nuevaFecha.setDate(nuevaFecha.getDate() + dias);
        } while (nuevaFecha.getDay() === 0 || nuevaFecha.getDay() === 6);
        
        setFechaActual(nuevaFecha);
    };

    // Formateo de Fecha central
    const formatearFechaDisplay = (fecha) => {
        const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return fecha.toLocaleDateString('es-ES', opciones);
    };

    // FUncion ayuda Para Extraer Fechas en Hora Local
    const obtenerFechaLocalISO = (fecha) => {
            const d = new Date(fecha);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
    };

    // Comprobar si la HPT cae dentro del día mostrado en calendario
    const comprobarEstadoPlanificacion = (hpt, fechaCalendarioObj) => {
        // Si esta cerrado no aparece
        if (hpt.estado_manual === 'CERRADO') return null;

        if (!hpt.fecha_prevista) return null;

        const diaSemanaCalendario = fechaCalendarioObj.getDay();
        if (diaSemanaCalendario === 0 || diaSemanaCalendario === 6) return null;

        // Nueva por funcion en lugar toISOString
        const fechaCalendarioStr = obtenerFechaLocalISO(fechaCalendarioObj);
        const fechaInicioStr = obtenerFechaLocalISO(hpt.fecha_prevista);
        

        // Creamos el objeto de fecha y reseteamos la hora para que la suma de días sea exacta
        const fechaInicioObj = new Date(hpt.fecha_prevista);
        fechaInicioObj.setHours(0, 0, 0, 0);
        //const fechaInicioObj = new Date(fechaInicioStr);
        const diasDuracion = parseInt(hpt.dias_previstos) || 1;

        // Calculamos fecha fin
        const fechaFinObj = new Date(fechaInicioObj);
        let diasRestantes = diasDuracion - 1;
        while (diasRestantes > 0) {
            // Sumamos un día al calendario
            fechaFinObj.setDate(fechaFinObj.getDate() + 1);
            
            // Comprobamos qué día de la semana es (0 = Domingo, 6 = Sábado)
            const diaSemana = fechaFinObj.getDay();
            
            // Si NO es sábado (6) y NO es domingo (0), contamos como día válido de trabajo
            if (diaSemana !== 0 && diaSemana !== 6) {
                diasRestantes--;
            }
        }

        //Obtenemos la fecha de fin en hora local
        const fechaFinStr = obtenerFechaLocalISO(fechaFinObj);

        // Si el día cae en el rango de trabajo activo de la HPT
        if (fechaCalendarioStr >= fechaInicioStr && fechaCalendarioStr <= fechaFinStr) {
            // Si el usuario forzó manualmente APERTURA o RENOVACION, pintamos ese valor estático
            if (hpt.estado_manual === 'APERTURA' || hpt.estado_manual === 'RENOVACION') {
                return hpt.estado_manual;
            }
            // Si no hay estado manual, ejecutamos tu cálculo automático tradicional
            return (fechaCalendarioStr === fechaInicioStr) ? 'APERTURA' : 'RENOVACION';
        }
        
        // Si no está en el rango no la muetra
        return null;
    };

    // Función para asignar color de fila según el departamento
    const getColorPorDepartamento = (grupo) => {
        if (!grupo) return 'row-default';
        const g = grupo.toUpperCase();
        
        if (g.includes('MECANICO') || g.includes('SPMecanico')) return 'row-mecanico';
        if (g.includes('CAMPO SOLAR') || g.includes('SPMecanico'))  return 'row-camposolar';
        if (g.includes('ELECTRICOS') || g.includes('SPElectrico')) return 'row-electrico';
        if (g.includes('INSTRUMENTACION') || g.includes('SPElectrico')) return 'row-instrumentacion';
        if (g.includes('QUIMICO') || g.includes('SPQuimicio')) return 'row-quimico';
        if (g.includes('Operacion') || g.includes('JEFE_TURNO')) return 'row-operacion';
        
        return 'row-default';
    };

    // Función para obtener el COLOR HEX (Para el correo electrónico)
    const getHexColorPorDepartamento = (grupo) => {
        if (!grupo) return '#ffffff';
        const g = grupo.toUpperCase();
        if (g.includes('MECANICO') || g.includes('SPMecanico')) return '#BF9000';
        if (g.includes('CAMPO SOLAR') || g.includes('SPMecanico')) return '#93C47D';
        if (g.includes('ELECTRICOS') || g.includes('SPElectrico')) return '#FFE599';
        if (g.includes('INSTRUMENTACION') || g.includes('SPElectrico')) return '#A6CAEC';
        if (g.includes('QUIMICO') || g.includes('SPQuimico')) return '#ff06b4';
        if (g.includes('Operacion') || g.includes('JEFE_TURNO')) return '#EAD1DC';
        return '#ffffff';
    };

    // Filtramos lista para solo ver la que toca en esa fecha de calendario
    const hptsDelDia = hptsCompletas.map(hpt => ({
        ...hpt,
        estado_diario: comprobarEstadoPlanificacion(hpt, fechaActual)
    })).filter(hpt => hpt.estado_diario !== null); // Quitamos las que devuelven null

    // Formateo
    const formatearLotoParaTabla = (arrLoto) => {
        if (!arrLoto || !Array.isArray(arrLoto) || arrLoto.length === 0) return '-';
        return arrLoto.map(item => {
            // Retrocompatibilidad por si hubiera algún texto viejo guardado
            if (typeof item === 'string') return item; 
            const num = item.num_consignacion ? `${item.num_consignacion}` : '';
            return `${num} `;
        }).join();
    };

    // ============================================================================
    // LÓGICA DEL PORTAPAPELES
    // ============================================================================
    const copiarAlPortapapeles = async () => {
        if (hptsDelDia.length === 0) {
            Swal.fire('Aviso', 'No hay planificaciones para este día.', 'info');
            return;
        }

        // Constructor Texto plano para la tabla
        let textoPlano = `PLANIFICACIÓN DE TRABAJOS - ${formatearFechaDisplay(fechaActual).toUpperCase()}\n\n`;
        
        // Usamos CSS inline debido a que al inyectar a HTML los correos borran los estilos.
        let htmlCorreo = `
            <div style="font-family: 'Segoe UI', Arial, sans-serif; color: #333;">
                <h2 style="color: #000000; border-bottom: 2px solid #1a237e; padding-bottom: 5px;">
                    PLANIFICACIÓN DE TRABAJOS PARA EL ${formatearFechaDisplay(fechaActual).toUpperCase()}
                </h2>
                <table style="border-collapse: collapse; width: 100%; border: 1px solid #dddddd; font-size: 13px;">
                    <thead>
                        <tr style="background-color: #ffffff; color: black; text-align: left;">
                            <th style="padding: 10px; border: 1px solid #000000;">Nº PTW</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Nº OT</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Ubicación</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Descripción del trabajo</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Activo</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Observaciones</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Descargo Eléctrico</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Bloqueo Eléctrico</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Descargo Mecánico</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Horario</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Fecha de Inicio</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Jefe Trabajo</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Recurso Prev.</th>
                            <th style="padding: 10px; border: 1px solid #000000;">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
        `;

        hptsDelDia.forEach((hpt, index) => {
            // Añadimos al texto plano
            textoPlano += `[OT: ${hpt.ot_referencia}] - ${hpt.titulo} (${hpt.estado_diario})\n`;

            // Añadimos Fila coloreada.
            const bgColor = getHexColorPorDepartamento(hpt.creador_grupo);
            const statusColor = hpt.estado_diario === 'APERTURA' ? '#2e7d32' : '#ef6c00';
            
            htmlCorreo += `
                <tr style="background-color: ${bgColor};">
                    <td style="padding: 8px; border: 1px solid #000000; font-weight: bold;">${hpt.numero_ptw || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.ot_referencia}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.nombre_zona || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;"><strong>${hpt.titulo || '-'}</strong><br/></td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.codigo_activo || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.descripcion_trabajo || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000; text-align: center;">${formatearLotoParaTabla(hpt.descargos_electricos)}</td>
                    <td style="padding: 8px; border: 1px solid #000000; text-align: center;">${formatearLotoParaTabla(hpt.bloqueos_electricos)}</td>
                    <td style="padding: 8px; border: 1px solid #000000; text-align: center;">${hpt.descargos_mecanicos?.length > 0 ? hpt.descargos_mecanicos.join(', ') : '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.horario_previsto || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.fecha_prevista || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.nombre} ${hpt.apellidos}</td>
                    <td style="padding: 8px; border: 1px solid #000000;">${hpt.recurso_preventivo || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #000000; color: ${statusColor}; font-weight: bold;">${hpt.estado_diario}</td>
                </tr>
            `;
        });

        // Ejecutamos la API para Portapapeles
        try {
            const blobHtml = new Blob([htmlCorreo], { type: "text/html" });
            const blobText = new Blob([textoPlano], { type: "text/plain" });

            const data = [new window.ClipboardItem({ 
                "text/html": blobHtml, 
                "text/plain": blobText 
            })];

            await navigator.clipboard.write(data);
            
            Swal.fire({
                title: '¡Tabla Copiada!',
                text: 'Abre tu correo (Outlook/Gmail) y dale a Pegar (Ctrl+V).',
                icon: 'success',
                timer: 3000,
                showConfirmButton: false
            });
        } catch (err) {
            console.error("Error al usar Clipboard API:", err);
            Swal.fire('Atención', 'Tu navegador no soporta la copia de tablas HTML, intenta usar Chrome o Edge.', 'warning');
        }
    };

    // ============================================================================
    // LÓGICA EXCELJS
    // ============================================================================
    const exportarAExcel = async () => {
        if (hptsDelDia.length === 0) {
            Swal.fire('Aviso', 'No hay planificaciones para exportar en este día.', 'info');
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Planificación Diaria');

        worksheet.columns = [
            { header: 'Nº PTW', key: 'ptw', width: 12 },
            { header: 'Nº OT', key: 'ot', width: 15 },
            { header: 'Ubicación', key: 'ubicacion', width: 25 },
            { header: 'Descripción del trabajo', key: 'titulo', width: 40 },
            { header: 'Activo', key: 'activo', width: 20 },
            { header: 'Observaciones', key: 'observaciones', width: 40 },
            { header: 'Descargo Eléctrico', key: 'de', width: 25 },
            { header: 'Bloqueo Eléctrico', key: 'be', width: 25 },
            { header: 'Descargo Mecánico', key: 'dm', width: 25 },
            { header: 'Horario', key: 'horario', width: 15 },
            { header: 'Fecha de Inicio', key: 'fecha', width: 18 },
            { header: 'Jefe Trabajo', key: 'jefe', width: 30 },
            { header: 'Recurso Prev.', key: 'preventivo', width: 20 },
            { header: 'Estado', key: 'estado', width: 15 }
        ];

        // Diseño de cabecera (Azul oscuro, letras blancas)
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A237E' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
        });

        // Insertamos Datos en celdas
        hptsDelDia.forEach(hpt => {
            const row = worksheet.addRow({
                ptw: hpt.numero_ptw || '-',
                ot: hpt.ot_referencia,
                ubicacion: hpt.nombre_zona || '-',
                titulo: hpt.titulo || '-',
                activo: hpt.codigo_activo || '-',
                observaciones: hpt.descripcion_trabajo || '-',
                de: formatearLotoParaTabla(hpt.descargos_electricos),
                be: formatearLotoParaTabla(hpt.bloqueos_electricos),
                dm: hpt.descargos_mecanicos?.length > 0 ? hpt.descargos_mecanicos.join(', ') : '-',
                horario: hpt.horario_previsto || '-',
                fecha: hpt.fecha_prevista ? new Date(hpt.fecha_prevista).toLocaleDateString('es-ES') : '-',
                jefe: `${hpt.nombre} ${hpt.apellidos}`,
                preventivo: hpt.recurso_preventivo || '-',
                estado: hpt.estado_diario
            });

            // Conversion del color que obtenemos para codigo ARGB
            let rawHex = getHexColorPorDepartamento(hpt.creador_grupo).replace('#', '');
            if(rawHex === 'ffffff') rawHex = 'ffffff'; // Dejamos blanco normal si no hay grupo
            const argbColor = rawHex === 'ffffff' ? 'FFFFFFFF' : `FF${rawHex}`;
            row.eachCell((cell) => {
                // Color de fondo
                if(argbColor !== 'FFFFFFFF'){
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: argbColor } };
                }
                // Alineación vertical y ajuste de texto
                cell.alignment = { vertical: 'middle', wrapText: true };
                // Bordes
                cell.border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
            });
        });

        // Descargar archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const fechaParaNombre = fechaActual.toISOString().split('T')[0];
        saveAs(new Blob([buffer]), `Planificacion_HPT_${fechaParaNombre}.xlsx`);
    };

    // ============================================================================
    // EDICIÓN DE DESCARGOS
    // ============================================================================
    const handleEditarDescargos = async (hpt) => {
        const { value: dmString } = await Swal.fire({
            title: 'Editar Descargos',
            html: `
                <div style="text-align: left; font-size: 14px; color: #333;">
                    <label style="margin-top: 15px; display: block; font-weight: bold;">Descargos Mecánicos (Texto Libre):</label>
                    <input id="swal-dm" class="swal2-input" style="margin-top: 5px; width: 90%;" placeholder="Ej: DM-26/0023, DM-26121" value="${hpt.descargos_mecanicos?.join(', ') || ''}">
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Guardar Mecánicos',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#1a237e',
            preConfirm: () => {
                const dm = document.getElementById('swal-dm').value;
                return dm;
            }
        });

        if (dmString !== undefined) {
            try {
                const token = localStorage.getItem('userToken');
                const stringToArray = (str) => str.split(',').map(s => s.trim()).filter(Boolean);
                const arrayMecanicos = stringToArray(dmString);

                const payload = {
                    descargos_electricos: hpt.descargos_electricos || [],
                    bloqueos_electricos: hpt.bloqueos_electricos || [],
                    descargos_mecanicos: arrayMecanicos
                };
                // Guardamos en el backend
                await axios.put(`${API_URL}/api/hpt/${hpt.id_hpt}/descargos`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Actualizamos la tabla en pantalla AL INSTANTE sin recargar
                setHptsCompletas(prev => prev.map(item => {
                    if (item.id_hpt === hpt.id_hpt) {
                        return { ...item, descargos_mecanicos: arrayMecanicos };
                    }
                    return item;
                }));
                
                // Pequeña notificación de éxito (Toast)
                Swal.fire({
                    title: '¡Guardado!',
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
            } catch (e) {
                console.error("Error al guardar mecánicos:", e);
                Swal.fire('Error', 'No se pudieron guardar los descargos mecánicos.', 'error');
            }
        }
    };

    // --- Lógica de Apertura del Formulario LOTO ---
    const abrirModalLoto = (hptObj, tipo) => {
        setHptSeleccionada(hptObj);
        setTipoLoto(tipo);
        
        // Extraemos las filas que ya tiene guardadas la HPT según la celda pulsada
        const filasOriginales = tipo === 'descargo_electrico' 
            ? (hptObj.descargos_electricos || []) 
            : (hptObj.bloqueos_electricos || []);
            
        // Las cargamos en el buffer local inyectando propiedades de control de texto e interfaz
        setFilasLotoTmp(filasOriginales.map(item => ({
            ...item,
            textoBusqueda: item.activo || '',
            mostrarDesplegable: false
        })));
        
        setShowLotoModal(true);
    };

    // --- Manipulación del buffer temporal de filas ---
    const addFilaLotoTmp = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setFilasLotoTmp([...filasLotoTmp, {
            num_consignacion: numAleatorio, id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '', num_candado: null, textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const addFilaLotoManualTmp = () => {
        if (!numManualLoto) return;
        setFilasLotoTmp([...filasLotoTmp, {
            num_consignacion: parseInt(numManualLoto),
            id_item: '',
            activo: 'MANUAL',
            centro_cargas: '-',
            ubicacion: '-',
            tension: 0,
            descripcion: ptwVinculadoLoto ? `LOTO vinculado al PTW: ${ptwVinculadoLoto}` : 'Consignación existente añadida manualmente',
            textoBusqueda: ptwVinculadoLoto ? `[MANUAL] Nº ${numManualLoto} (PTW: ${ptwVinculadoLoto})` : `[MANUAL] Nº ${numManualLoto}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoLoto || null
        }]);
        setNumManualLoto('');
        setPtwVinculadoLoto('');
    };

    const handleFilaLotoTmpChange = (idx, texto) => {
        const nuevasFilas = [...filasLotoTmp];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setFilasLotoTmp(nuevasFilas);
    };

    const seleccionarElementoLotoTmp = (idx, elemento) => {
        const nuevasFilas = [...filasLotoTmp];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo,
            mostrarDesplegable: false
        };
        setFilasLotoTmp(nuevasFilas);
    };

    // --- Guardado definitivo en el Servidor ---
    const handleGuardarLotoPlanificador = async () => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        
        // Filtramos para limpiar filas vacías que el usuario no haya completado con el buscador
        const filasPurgadas = filasLotoTmp.filter(f => f.activo !== '');

        // Construimos el payload respetando el estado de la otra rama LOTO y los mecánicos
        const payload = {
            interviene_subcontrata: hptSeleccionada.interviene_subcontrata === 1,
            descargos_mecanicos: hptSeleccionada.descargos_mecanicos || [],
            descargos_electricos: tipoLoto === 'descargo_electrico' ? filasPurgadas : (hptSeleccionada.descargos_electricos || []),
            bloqueos_electricos: tipoLoto === 'bloqueo_electrico' ? filasPurgadas : (hptSeleccionada.bloqueos_electricos || [])
        };

        try {
            // Atacamos a tu endpoint existente PUT /:id/descargos
            await axios.put(`${API_URL}/api/hpt/${hptSeleccionada.id_hpt}/descargos`, payload, config);
            
            // Refrescamos el estado local en memoria para ver las celdas actualizadas al instante
            setHptsCompletas(prev => prev.map(item => {
                if (item.id_hpt === hptSeleccionada.id_hpt) {
                    return {
                        ...item,
                        descargos_electricos: payload.descargos_electricos,
                        bloqueos_electricos: payload.bloqueos_electricos
                    };
                }
                return item;
            }));

            Swal.fire({
                title: '¡LOTO Guardado!',
                icon: 'success',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            setShowLotoModal(false);
        } catch (error) {
            console.error("Error guardando LOTO desde el planificador:", error);
            Swal.fire('Error', 'No se pudieron guardar las modificaciones LOTO.', 'error');
        }
    };

    // ============================================================================
    // CAMBIO MANUAL DE ESTADO DIARIO
    // ============================================================================
    const handleCambiarEstadoDiario = async (hptObj) => {
        const { value: nuevoEstado } = await Swal.fire({
            title: 'Modificar Estado de Ejecución',
            text: `Selecciona el estado definitivo para la OT: ${hptObj.ot_referencia}`,
            input: 'select',
            inputOptions: {
                '': 'Automático (Cálculo por calendario)',
                'APERTURA': 'Forzar APERTURA',
                'RENOVACION': 'Forzar RENOVACIÓN (+1 Día a la duración)',
                'CERRADO': 'CERRADO (Quitar de la lista)'
            },
            inputValue: hptObj.estado_manual || '',
            showCancelButton: true,
            confirmButtonColor: '#1a237e',
            cancelButtonColor: '#999',
            confirmButtonText: 'Guardar Estado',
            cancelButtonText: 'Cancelar'
        });

        // Si el usuario confirma y no da a cancelar
        if (nuevoEstado !== undefined) {
            try {
                const token = localStorage.getItem('userToken');
                // Si elige "Automático", mandamos NULL para limpiar la columna
                const valorEnviar = nuevoEstado === '' ? null : nuevoEstado;

                const res = await axios.put(`${API_URL}/api/hpt/${hptObj.id_hpt}/estado-manual`, {
                    estado_manual: valorEnviar
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                const nuevosDiasCalculados = res.data.dias_previstos;

                setHptsCompletas(prev => prev.map(item => {
                    if (item.id_hpt === hptObj.id_hpt) {
                        return { 
                            ...item, 
                            estado_manual: valorEnviar,
                            dias_previstos: nuevosDiasCalculados || item.dias_previstos
                        };
                    }
                    return item;
                }));

                Swal.fire({
                    title: '¡Estado guardado!',
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
            } catch (error) {
                console.error("Error al actualizar estado diario:", error);
                Swal.fire('Error', error.response?.data?.error || 'No se pudo actualizar el estado de la HPT.', 'error');
            }
        }
    };

    const handleReprogramarFecha = async (hptObj) => {
        // Calculamos la fecha máxima permitida (Original + 15 días)
        const fechaOriginal = new Date(hptObj.fecha_prevista_original || hptObj.fecha_prevista);
        fechaOriginal.setDate(fechaOriginal.getDate() + 15);
        const maxDateStr = fechaOriginal.toISOString().split('T')[0];
        const hoyStr = new Date().toISOString().split('T')[0];

        const { value: nuevaFecha } = await Swal.fire({
            title: 'Reprogramar Trabajo',
            html: `
                <p style="font-size: 14px;">La fecha original es: <b>${hptObj.fecha_prevista_original || hptObj.fecha_prevista}</b></p>
                <p style="font-size: 12px; color: #666;">Solo se puede posponer un máximo de 15 días.</p>
                <input type="date" id="swal-nueva-fecha" class="swal2-input" min="${hoyStr}" max="${maxDateStr}" value="${hptObj.fecha_prevista}">
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Posponer y Avisar',
            confirmButtonColor: '#f57c00',
            preConfirm: () => {
                const dateVal = document.getElementById('swal-nueva-fecha').value;
                if (!dateVal) Swal.showValidationMessage('Debes elegir una fecha');
                return dateVal;
            }
        });

        if (nuevaFecha) {
            try {
                const token = localStorage.getItem('userToken');
                await axios.put(`${API_URL}/api/hpt/${hptObj.id_hpt}/posponer`, { nueva_fecha: nuevaFecha }, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                Swal.fire('¡Reprogramado!', 'La fecha ha cambiado y se ha notificado a los implicados.', 'success');
                
                // Actualizamos la lista local y forzamos re-filtrado
                setHptsCompletas(prev => prev.map(item => item.id_hpt === hptObj.id_hpt ? { ...item, fecha_prevista: nuevaFecha, estado_manual: null } : item));
                
            } catch (error) {
                Swal.fire('Error', error.response?.data?.error || 'No se pudo posponer.', 'error');
            }
        }
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addBloqueoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeBloqueoElectrico = (idx) => {
        setBloqueosElectricos(bloqueosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaBloqueoChange = (idx, texto) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        // Si borra el texto, limpiamos el bloqueo seleccionado
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setBloqueosElectricos(nuevasFilas);
    };

    const toggleBloqueoDesplegable = (idx, visible) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setBloqueosElectricos(nuevasFilas);
    };

    const seleccionarElementoBloqueoElectrico = (idx, elemento) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo, // Dejamos el Tag visible en el input
            mostrarDesplegable: false // Cerramos su desplegable
        };
        setBloqueosElectricos(nuevasFilas);
    };



    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addDescargoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeDescargoElectrico = (idx) => {
        setDescargosElectricos(descargosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaDescargoChange = (idx, texto) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        // Si borra el texto, limpiamos el descargo seleccionado
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setDescargosElectricos(nuevasFilas);
    };

    const toggleDescargoDesplegable = (idx, visible) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setDescargosElectricos(nuevasFilas);
    };

    const seleccionarElementoDescargoElectrico = (idx, elemento) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo, // Dejamos el Tag visible en el input
            mostrarDesplegable: false // Cerramos su desplegable
        };
        setDescargosElectricos(nuevasFilas);
    };

    // ============================================================================
    // GUARDAR CANDADOS DESDE LAS HOJAS DE VISTA
    // ============================================================================
    const handleGuardarCandadoBloqueoPlanificador = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const bloqueosActualizados = hptLotoActiva.bloqueos_electricos.map(b => 
            b.id_item === viewBloqueoActivo.id_item ? { ...b, num_candado: nuevoNumeroCandado } : b
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${hptLotoActiva.id_hpt}/descargos`, {
                bloqueos_electricos: bloqueosActualizados,
                descargos_electricos: hptLotoActiva.descargos_electricos || [],
                descargos_mecanicos: hptLotoActiva.descargos_mecanicos || []
            }, config);

            Swal.fire({ title: 'Candado Registrado', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 2000 });
            setShowViewBloqueoModal(false);
            setHptsCompletas(prev => prev.map(item => item.id_hpt === hptLotoActiva.id_hpt ? { ...item, bloqueos_electricos: bloqueosActualizados } : item));
        } catch (error) {
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };

    const handleGuardarCandadoDescargoPlanificador = async (nuevoNumeroCandado) => {
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const descargosActualizados = hptLotoActiva.descargos_electricos.map(d => 
            d.id_item === viewDescargoActivo.id_item ? { ...d, num_candado: nuevoNumeroCandado } : d
        );

        try {
            await axios.put(`${API_URL}/api/hpt/${hptLotoActiva.id_hpt}/descargos`, {
                bloqueos_electricos: hptLotoActiva.bloqueos_electricos || [],
                descargos_electricos: descargosActualizados,
                descargos_mecanicos: hptLotoActiva.descargos_mecanicos || []
            }, config);

            Swal.fire({ title: 'Candado Registrado', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 2000 });
            setShowViewDescargoModal(false);
            setHptsCompletas(prev => prev.map(item => item.id_hpt === hptLotoActiva.id_hpt ? { ...item, descargos_electricos: descargosActualizados } : item));
        } catch (error) {
            Swal.fire('Error', 'No se pudo actualizar el candado.', 'error');
        }
    };

    // ============================================================================
    // IMPRIMIR DESDE PLANIFICADOR
    // ============================================================================
    const handleImprimirDesdePlanificador = async (idHpt, numeroPtw) => {

        // Extraemos valores y pantalla de carga.
        Swal.fire({
            title: 'Recopilando datos...',
            text: 'Comprobando anexos, bloqueos, descargos etc...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
        });

        try {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };

            // Traemos los datos en particular de la HPT antes de monstrar menu
            const [resHpt, resSeg, resCat] = await Promise.all([
                axios.get(`${API_URL}/api/hpt/${idHpt}`, config),
                axios.get(`${API_URL}/api/hpt/${idHpt}/seguimiento-firmas`, config),
                axios.get(`${API_URL}/api/catalogos/seguridad`, config)
            ]);

            const hptDescargada = resHpt.data;

            // Mostramos menu al usuario bloqueando si no tiene esos datos
            const { value: opciones, isConfirmed } = await Swal.fire({
                title: 'Configurar PDF',
                html: `
                    <div style="text-align: left; display: flex; flex-direction: column; gap: 8px; font-size: 14px;">
                        <label><input type="checkbox" id="pdf-base" checked> 1. Planificación Base</label>
                        <label><input type="checkbox" id="pdf-trab" ${hptDescargada.trabajadores?.length > 0 ? 'checked' : 'disabled'}> 2. Personal Externo y Habilitaciones</label>
                        <label><input type="checkbox" id="pdf-esc" ${hptDescargada.anexo_escalera ? 'checked' : 'disabled'}> 3. Permiso Escalera</label>
                        <label><input type="checkbox" id="pdf-plat" ${hptDescargada.anexo_plataforma ? 'checked' : 'disabled'}> 4. Checklist Plataforma Elevadora</label>
                        <hr style="margin: 5px 0; border: 0.5px solid #ccc;"/>
                        <label><input type="checkbox" id="pdf-bloq-a4" ${hptDescargada.bloqueos_electricos?.length > 0 ? '' : 'disabled'}> 5. Bloqueos: Hoja de Consignación</label>
                        <label><input type="checkbox" id="pdf-bloq-a5" ${hptDescargada.bloqueos_electricos?.length > 0 ? '' : 'disabled'}> 6. Bloqueos: Tarjetas (Frontal y Reverso)</label>
                        <label><input type="checkbox" id="pdf-desc-a4" ${hptDescargada.descargos_electricos?.length > 0 ? '' : 'disabled'}> 7. Descargos: Hoja de Consignación</label>
                        <label><input type="checkbox" id="pdf-desc-a5" ${hptDescargada.descargos_electricos?.length > 0 ? '' : 'disabled'}> 8. Descargos: Tarjetas (Frontal y Reverso)</label>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Generar PDF',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#003366',
                preConfirm: () => {
                    return {
                        base: document.getElementById('pdf-base').checked,
                        trabajadores: document.getElementById('pdf-trab').checked,
                        escalera: document.getElementById('pdf-esc').checked,
                        plataforma: document.getElementById('pdf-plat').checked,
                        bloqueoA4: document.getElementById('pdf-bloq-a4').checked,
                        bloqueoA5: document.getElementById('pdf-bloq-a5').checked,
                        descargoA4: document.getElementById('pdf-desc-a4').checked,
                        descargoA5: document.getElementById('pdf-desc-a5').checked,
                    };
                }
            });

            // Si el usuario cancela, detenemos la ejecución
            if (!isConfirmed || !opciones) return;

            Swal.fire({
                title: 'Generando documento...',
                text: 'Por favor espera',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            // Estado par arender
            setOpcionesPdf(opciones);
            setDatosPdf({
                hpt: hptDescargada,
                seguimiento: resSeg.data,
                catalogo: resCat.data.results || resCat.data
            });

            // Le damos Margen a React para hacer captura
            setTimeout(() => {
                const element = pdfRef.current;
                const opt = {
                    margin:       [10, 5, 10, 5],
                    filename:     `HPT_${numeroPtw || 'Borrador'}.pdf`,
                    image:        { type: 'jpeg', quality: 0.8 },
                    html2canvas:  { scale: 2, useCORS: true },
                    jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                    pagebreak:    { mode: ['css', 'legacy'] }
                };
                html2pdf().set(opt).from(element).save().then(() => {
                    Swal.close();
                    setDatosPdf(null); // Limpiamos para memoria
                });
            }, 1200);

        } catch (error) {
            console.error("Error al generar PDF desde Planificador:", error);
            Swal.fire('Error', 'No se pudieron descargar los datos para el documento.', 'error');
        }
    };

    const handleVerLoto = async (e, elementoLoto, tipo, hptActual) => {
        e.stopPropagation(); 
        if (elementoLoto.ptw_vinculado) {
            Swal.fire({title: 'Buscando descargo original...', allowOutsideClick: false, didOpen: () => Swal.showLoading()});
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/ptw/loto/vinculado?ptw=${encodeURIComponent(elementoLoto.ptw_vinculado)}`, { 
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.close();
                
                const lista = tipo === 'bloqueo' ? res.data.bloqueos : res.data.descargos;
                const itemReal = lista.find(x => Number(x.num_consignacion) === Number(elementoLoto.num_consignacion));
                
                if (itemReal) {
                    setHptLotoActiva({ ...res.data.hpt, numero_ptw: elementoLoto.ptw_vinculado });
                    if (tipo === 'bloqueo') {
                        setViewBloqueoActivo(itemReal);
                        setShowViewBloqueoModal(true);
                    } else {
                        setViewDescargoActivo(itemReal);
                        setShowViewDescargoModal(true);
                    }
                } else {
                    Swal.fire('Aviso', `El PTW ${elementoLoto.ptw_vinculado} existe, pero no tiene registrado el número de consignación ${elementoLoto.num_consignacion}.`, 'warning');
                }
            } catch(error) {
                Swal.fire('Error', 'No se pudo cargar el PTW vinculado. Asegúrate de que está escrito correctamente.', 'error');
            }
        } else {
            setHptLotoActiva(hptActual);
            if (tipo === 'bloqueo') {
                setViewBloqueoActivo(elementoLoto);
                setShowViewBloqueoModal(true);
            } else {
                setViewDescargoActivo(elementoLoto);
                setShowViewDescargoModal(true);
            }
        }
    };


    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    if (loading) return <div className="loading-container">Cargando planificador...</div>;

    return (
        <div className="planner-wrapper">
            
            {/* CABECERA: Título y botón volver */}
            <div className="top-header" style={{ marginBottom: '20px' }}>
                <div className="d-flex align-center">
                    <span className="ptw-label">PLANIFICADOR DIARIO</span>
                </div>
                <div className="header-actions">
                    <button className="btn-excel"onClick={exportarAExcel}>
                        📊 Exportar Excel
                    </button>
                    <button className="btn-copy-clipboard" onClick={copiarAlPortapapeles}>
                        📋 Copiar Resumen
                    </button>
                    <button onClick={() => navigate('/dashboard')} className="btn-close">Volver al Dashboard</button>
                </div>
            </div>

            {/* CONTROLES DEL CALENDARIO */}
            <div className="planner-date-control">
                <button className="btn-date-nav" onClick={() => cambiarDia(-1)} title="Día Anterior">
                    ◀
                </button>
                
                <div className="current-date-display">
                    {formatearFechaDisplay(fechaActual)}
                </div>
                
                <button className="btn-date-nav" onClick={() => cambiarDia(1)} title="Día Siguiente">
                    ▶
                </button>
            </div>

            {/* TABLA DE PLANIFICACIONES */}
            <div className="table-container-scroll">
                <table className="planner-table">
                    <thead>
                        <tr>
                            <th>Nº PTW</th>
                            <th>Nº OT</th>
                            <th>Nº ST</th>
                            <th>Ubicación</th>
                            <th>Descripción del Trabajo</th>
                            <th>Activo</th>
                            <th>Observaciones</th>
                            <th>Descargo Eléct.</th>
                            <th>Bloqueo Eléct.</th>
                            <th>Descargo Mecán.</th>
                            <th>Horario</th>
                            <th>Fecha Inicio</th>
                            <th>Jefe Trabajo</th>
                            <th>Recurso Prev.</th>
                            <th>Estado</th>
                            <th>Descarga</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hptsDelDia.length > 0 ? (
                            hptsDelDia.map(hpt => (
                                <tr key={hpt.id_hpt} className={getColorPorDepartamento(hpt.creador_grupo)} onClick={() => navigate(`/detalles-hpt/${hpt.id_hpt}`)} style={{ cursor: 'pointer' }}>
                                    <td className="td-ot">{hpt.numero_ptw || '-'}</td>
                                    <td className="td-ot">{hpt.ot_referencia}</td>
                                    <td className="td-ot">{hpt.id_st || '-'}</td>
                                    <td>{hpt.nombre_zona || '-'}</td>
                                    <td className="td-title" title={hpt.titulo}>{hpt.titulo || '-'}</td>
                                    <td>{hpt.codigo_activo || '-'}</td>
                                    <td className="td-desc" title={hpt.descripcion_trabajo}>{hpt.descripcion_trabajo || '-'}</td>
                                    
                                    {/* Descargos y Bloqueos*/}
                                    {/* Celda: Descargo Eléctrico */}
                                    <td 
                                        className={`text-center ${puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('DESCARGO ELÉCTRICO') ? (hpt.descargos_electricos?.length > 0 ? 'editable-cell' : 'editable-cell-isEmpty' ) : ''}`} 
                                        onClick={(e) => {
                                            if (puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('DESCARGO ELÉCTRICO')) {
                                                e.stopPropagation(); 
                                                abrirModalLoto(hpt, 'descargo_electrico');
                                            } else {
                                                e.stopPropagation();
                                            }
                                        }}
                                        title={puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('DESCARGO ELÉCTRICO') ? "Clic para editar Descargos Eléctricos" : "Esta HPT no requiere descargo eléctrico"}
                                    >   
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
                                            {hpt.descargos_electricos?.length > 0 ? (
                                                hpt.descargos_electricos.map((d, dIdx) => (
                                                    <span 
                                                        key={dIdx} 
                                                        style={{ backgroundColor: '#ffe0b2', color: '#e65100', border: '1px solid #ffe0b2', borderRadius: '4px', padding: '3px 6px', fontSize: '10px', cursor: 'pointer', fontWeight: 'bold' }}
                                                        onClick={(e) => handleVerLoto(e, d, 'descargo', hpt)}
                                                        title="Ver Hoja de Descargo"
                                                    >
                                                        ⚡ {d.num_consignacion || 'S/N'}
                                                    </span>
                                                ))
                                            ) : (
                                                puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('DESCARGO ELÉCTRICO') ? 
                                                <span style={{color: '#999', fontSize: '11px'}}> Vacío </span> : '-'
                                            )}
                                        </div>
                                    </td>

                                    {/* Celda: Bloqueo Eléctrico */}
                                    <td 
                                        className={`text-center ${puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('ENCLAVAMIENTO ELÉCTRICO') ? (hpt.bloqueos_electricos?.length > 0 ? 'editable-cell' : 'editable-cell-isEmpty' ) : ''}`} 
                                        onClick={(e) => {
                                            if (puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('ENCLAVAMIENTO ELÉCTRICO')) {
                                                e.stopPropagation(); 
                                                abrirModalLoto(hpt, 'bloqueo_electrico');
                                            } else {
                                                e.stopPropagation();
                                            }
                                        }}
                                        title={puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('ENCLAVAMIENTO ELÉCTRICO') ? "Clic para editar Bloqueos Eléctricos" : "Esta HPT no requiere enclavamiento/bloqueo eléctrico"}
                                    >
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
                                            {hpt.bloqueos_electricos?.length > 0 ? (
                                                hpt.bloqueos_electricos.map((b, bIdx) => (
                                                    <span 
                                                        key={bIdx} 
                                                        style={{ backgroundColor: '#90caf9', color: '#1a237e', border: '1px solid #90caf9', borderRadius: '4px', padding: '3px 6px', fontSize: '10px', cursor: 'pointer', fontWeight: 'bold' }}
                                                        onClick={(e) => handleVerLoto(e, b, 'bloqueo', hpt)}
                                                        title="Ver Hoja de Bloqueo"
                                                    >
                                                        🔒 {b.num_consignacion || 'S/N'}
                                                    </span>
                                                ))
                                            ) : (
                                                puedeEditarDescargos && hpt.recursos_energias?.toUpperCase().includes('ENCLAVAMIENTO ELÉCTRICO') ? 
                                                <span style={{color: '#999', fontSize: '11px'}}> Vacío </span> : '-'
                                            )}
                                        </div>
                                    </td>
                                    
                                    <td 
                                        className={`text-center ${puedeEditarDescargos ? 'editable-cell' : ''}`} 
                                        onClick={(e) => {
                                            if (puedeEditarDescargos) {
                                                e.stopPropagation(); 
                                                handleEditarDescargos(hpt);
                                            }
                                        }}
                                        title={puedeEditarDescargos ? "Clic para editar Descargos Mecánicos" : ""}
                                    >
                                        {hpt.descargos_mecanicos?.length > 0 ? hpt.descargos_mecanicos.join(', ') : '-'}
                                    </td>
                                    
                                    <td>{hpt.horario_previsto || '-'}</td>
                                    <td 
                                        className={puedeCambiarEstado ? 'editable-cell' : ''}
                                        onClick={(e) => {
                                            if (puedeCambiarEstado) {
                                                e.stopPropagation();
                                                handleReprogramarFecha(hpt);
                                            }
                                        }}
                                        title={puedeCambiarEstado ? "Clic para posponer fecha" : ""}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <span>{new Date(hpt.fecha_prevista).toLocaleDateString('es-ES')}</span>
                                            {puedeCambiarEstado && <span style={{ fontSize: '14px' }}>📅</span>}
                                        </div>
                                    </td>
                                    <td>{hpt.nombre} {hpt.apellidos}</td>
                                    <td>{hpt.recurso_preventivo || '-'}</td> 
                                    <td 
                                        className={puedeCambiarEstado ? 'editable-cell' : ''}
                                        onClick={(e) => {
                                            if (puedeCambiarEstado) {
                                                e.stopPropagation(); 
                                                handleCambiarEstadoDiario(hpt);
                                            }
                                        }}
                                        title={puedeCambiarEstado ? "Clic para modificar o cerrar este estado" : ""}
                                    >
                                        <span className={`status-pill-planner ${hpt.estado_diario === 'APERTURA' ? 'status-apertura' : 'status-renovacion'}`}>
                                            {hpt.estado_diario}
                                        </span>
                                    </td>
                                    <td>
                                        <button 
                                            className="btn-print" 
                                            title="Descargar PDF Completo"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleImprimirDesdePlanificador(hpt.id_hpt, hpt.numero_ptw);
                                            }}
                                        >
                                            🖨️ PDF
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="14" style={{ textAlign: 'center', padding: '30px', color: '#666' }}>
                                    No hay trabajos planificados finalizados (con todas las firmas) para esta fecha.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {/* === MODAL FLOTANTE: EDICIÓN DE LOTO ELÉCTRICO DESDE EL PLANIFICADOR === */}
                {showLotoModal && hptSeleccionada && (
                    <div className="modal-overlay" onClick={() => setShowLotoModal(false)}>
                        <div className="modal-content planner-modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="close-btn" onClick={() => setShowLotoModal(false)}>✖</button>
                            
                            <h3 className="planner-modal-title">
                                {tipoLoto === 'descargo_electrico' ? 'Gestionar Descargos Eléctricos' : 'Gestionar Bloqueos Eléctricos'}
                                <br></br>
                                <span className="planner-modal-subtitle">
                                    Modificando OT: <strong>{hptSeleccionada.ot_referencia}</strong> — {hptSeleccionada.titulo}
                                </span>
                            </h3>

                            <div className="loto-modal-scroll-container">
                                <table className="planner-table">
                                    <thead>
                                        <tr>
                                            <th className="loto-col-tag">Activo (Buscador)</th>
                                            <th className="loto-col-cc">Centro Cargas</th>
                                            <th className="loto-col-ubicacion">Ubicación / Tensión</th>
                                            <th className="loto-col-action">Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filasLotoTmp.map((fila, idx) => (
                                            <tr key={idx}>
                                                <td className="td-relative-loto">
                                                    <input 
                                                        type="text" 
                                                        className="main-input loto-input-predictive" 
                                                        placeholder="Escribe Tag (Ej: 00-V...)"
                                                        value={fila.textoBusqueda} 
                                                        onChange={(e) => handleFilaLotoTmpChange(idx, e.target.value)}
                                                        onFocus={() => {
                                                            const n = [...filasLotoTmp]; n[idx].mostrarDesplegable = true; setFilasLotoTmp(n);
                                                        }}
                                                        onBlur={() => setTimeout(() => {
                                                            const n = [...filasLotoTmp]; n[idx].mostrarDesplegable = false; setFilasLotoTmp(n);
                                                        }, 200)}
                                                    />
                                                    {fila.mostrarDesplegable && fila.textoBusqueda.length >= 2 && (
                                                        <ul className="autocomplete-list-modal">
                                                            {(tipoLoto === 'descargo_electrico' ? electricosDescargo : electricosBloqueo)
                                                                .filter(elem => elem.activo.toLowerCase().includes(fila.textoBusqueda.toLowerCase()))
                                                                .map(elemento => (
                                                                    <li 
                                                                        key={elemento.id_item} 
                                                                        className="autocomplete-item" 
                                                                        onMouseDown={() => seleccionarElementoLotoTmp(idx, elemento)}
                                                                    >
                                                                        <strong>{elemento.activo}</strong> <br/>
                                                                        <small className="text-muted">{elemento.centro_cargas} — {elemento.ubicacion}</small>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    )}
                                                </td>
                                                <td className="td td-loto-read">{fila.centro_cargas || '-'}</td>
                                                <td className="td td-loto-read">
                                                    {fila.ubicacion} {fila.descripcion ? `(${fila.descripcion})` : ''} 
                                                    {fila.tension ? ` — ${fila.tension}V` : ''}
                                                </td>
                                                <td className="td text-center">
                                                    <button 
                                                        type="button" 
                                                        className="del-btn" 
                                                        style={{ padding: '3px 8px', fontSize: '12px' }}
                                                        onClick={() => setFilasLotoTmp(filasLotoTmp.filter((_, i) => i !== idx))}
                                                    >
                                                        ➖ Quitar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="loto-modal-footer-flex">
                                <button 
                                    type="button" 
                                    className="add-btn" 
                                    style={{ backgroundColor: '#2e7d32', padding: '8px 16px', marginTop: '0' }} 
                                    onClick={addFilaLotoTmp}
                                >
                                    ➕ Añadir Nuevo Tag
                                </button>

                                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                    <input 
                                        type="number" 
                                        className="main-input" 
                                        placeholder="Nº Consignación..." 
                                        value={numManualLoto}
                                        onChange={(e) => setNumManualLoto(e.target.value)}
                                        style={{ width: '130px' }}
                                    />
                                    <input 
                                        type="text" 
                                        className="main-input" 
                                        placeholder="PTW Origen (Ej: 26/0045)" 
                                        value={ptwVinculadoLoto}
                                        onChange={(e) => setPtwVinculadoLoto(e.target.value)}
                                        style={{ width: '180px' }}
                                    />
                                    <button 
                                        type="button" 
                                        className="btn-save" 
                                        style={{ padding: '8px 16px' }} 
                                        onClick={addFilaLotoManualTmp}
                                    >
                                        Vincular
                                    </button>
                                </div>
                                
                                <div className="loto-modal-footer-buttons">
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        style={{ padding: '8px 16px' }} 
                                        onClick={() => setShowLotoModal(false)}
                                    >
                                        Cancelar
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn-save" 
                                        style={{ padding: '8px 16px' }} 
                                        onClick={handleGuardarLotoPlanificador}
                                    >
                                        💾 Guardar Cambios
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </div>

            {/* COMPONENTE FLOTANTE: HOJA DE ENCLAVAMIENTO (VISTA/IMPRESIÓN) */}
            {showViewBloqueoModal && viewBloqueoActivo && hptLotoActiva && (
                <BloqueoElectrico 
                    bloqueo={viewBloqueoActivo}
                    hpt={hptLotoActiva}
                    onSave={handleGuardarCandadoBloqueoPlanificador}
                    onCancel={() => setShowViewBloqueoModal(false)}
                />
            )}

            {/* COMPONENTE FLOTANTE: HOJA DE DESCARGO (VISTA/IMPRESIÓN) */}
            {showViewDescargoModal && viewDescargoActivo && hptLotoActiva && (
                <DescargoElectrico 
                    descargo={viewDescargoActivo}
                    hpt={hptLotoActiva}
                    onSave={handleGuardarCandadoDescargoPlanificador}
                    onCancel={() => setShowViewDescargoModal(false)}
                />
            )}

        </div>
    );
};

export default PlanificadorScreen;